module.exports = __webpack_public_path__ + "img/sable-orange.3c6974bb.svg";